import React from 'react';
import clsx from 'clsx';
import classNames from 'classnames';
import makeStyles from '@material-ui/styles/makeStyles';
import EditIcon from '@material-ui/icons/Edit';
import { IconButton } from '@material-ui/core';
import { useCallback } from 'react';
const useStyles = makeStyles(() => ({
    root: {
        minHeight:'3em',
    },
    cell: {
        height:'3em',
        backgroundSize:'contain',
        backgroundPosition:'center',
        backgroundRepeat:'no-repeat',
        textAlign:'right',
    },
    overlayBtn:{
      opacity:'.5',
      transition:'opacity .2s ease-in-out',
      '&:hover':{
        opacity:'1',
      }
    }
}));

export function ImageFormatter({ value, cell, row }) {
  // const editClick = useCallback(()=>{
  //   console.log('editing image for',row, cell);
  // });
  const classes = useStyles();
  return (
    <div className={clsx(classes.root,"rdg-image-cell-wrapper")}>
      <div className={clsx(classes.cell,"rdg-image-cell")} style={{ backgroundImage: `url(${value})` }}>
        {/* <IconButton onClick={editClick} className={classes.overlayBtn} color="primary" size="small" edge="end" aria-label="upload new image">
          <EditIcon />
        </IconButton> */}
        </div>      
    </div>
  );
}